import { getClient as e, registerEntityEndpoint as t } from "@editor/ui-utils";
//#region src/services/channel.service.ts
var n = "Channels", r = t(n), { listEntities: i, getEntity: a, postEntity: o, putEntity: s, deleteEntity: c } = r, l = async (e, t = {}) => i({ params: {
	search: e,
	...t
} }), u = async (e) => a(e), d = async (e) => i({ params: {
	...e,
	isRootChannel: !0
} }), f = async (e, t) => i({ params: {
	...t,
	parentUuid: e
} }), p = async (e) => await o(e), m = async (e) => await s(e._id, e), h = async (e) => await c(e), g = async (t, n) => (await e().get(`/cms/channels/depth/${t}`, n)).data, _ = () => ({
	type: "CHANNEL",
	brand: "bunte",
	title: "",
	metaTitle: "",
	metaDescription: "",
	bfJobId: void 0,
	parentUuid: void 0,
	isRootChannel: !1,
	isAdsEnabled: !0,
	isEnabled: !1,
	tags: [],
	breadcrumb: [],
	paths: [],
	hasDefaultSettings: !0,
	blocks: []
}), v = async (t, n) => (await e().put(`/cms/channels/${t}/legacy-migration`, n)).data, y = async (t) => {
	let n = await e().get(`/cms/channels/check-articles/${t}`);
	return n.data && !n.data.hasPublishedArticles;
}, b = (e, t) => !e || e.length <= 1 ? t || "" : e.slice(1).map((e) => e.title).join(" > "), x = async (t) => (await e().get(`/cms/channels/${t}/check-path-conflict`)).data, S = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
//#endregion
export { x as a, b as c, _ as d, f, v as g, m as h, y as i, u as l, p as m, n, h as o, d as p, r, g as s, S as t, l as u };

//# sourceMappingURL=_plugin-vue_export-helper-CsYjOJ0s.js.map